import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './SettingList.module.scss'

import ArrowRight from '@Root/ui/images/myhouse/ArrowRight.svg'
import { NCLICK } from '@Root/contants/lcs'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { handleNclick } from '@Root/helpers/nclick'
import useMain from '@Root/hooks/myhouse/main/useMain'

const cx = className.bind(style)

const SettingList = () => {
  const history = useHistory()
  const { reduxMain } = useMain()
  const { currentHouseNo } = reduxMain

  const notifyUrl = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/notify/settings${currentHouseNo > 0 ? '/' + currentHouseNo : ''}?back=myhouse`
  const registerUrl = `${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/settings`

  const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement>, href: string, nclickCode: string) => {
    event.preventDefault()
    handleNclick(nclickCode, event)

    history.push(href)
  }

  return (
    <ul className={cx('article')}>
      <li className={cx('item')}>
        <a href={notifyUrl} className={cx('link')} onClick={(e) => handleLinkClick(e, notifyUrl, NCLICK.MY_HOUSE.MENU.NOTIFY)}>
          우리집 알림 설정
          <span className={cx('icon')}>
            <ArrowRight />
          </span>
        </a>
      </li>
      <li className={cx('item')}>
        <a href={registerUrl} className={cx('link')} onClick={(e) => handleLinkClick(e, registerUrl, NCLICK.MY_HOUSE.MENU.SETTING)}>
          우리집 추가 및 삭제
          <span className={cx('icon')}>
            <ArrowRight />
          </span>
        </a>
      </li>
    </ul>
  )
}

export default SettingList
